module.exports = __webpack_public_path__ + "img/choose-document.21c475f2.svg";